"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../../styles/styles"));
const dateComponent_1 = __importDefault(require("../../dateComponent/dateComponent"));
const label_1 = __importDefault(require("../../label/label"));
const AccountInfoContent = ({ borrower }) => (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
    react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
        react_1.default.createElement(label_1.default, { subheading: "Date of Registration", title: react_1.default.createElement(dateComponent_1.default, { date: borrower.datetime_of_registration }) }),
        react_1.default.createElement(label_1.default, { subheading: "App Version", title: borrower.app_version })),
    react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne }, borrower.user_system_status ? (react_1.default.createElement(label_1.default, { subheading: "User System Status", title: borrower.user_system_status })) : null)));
exports.default = AccountInfoContent;
